import {isNoticeDismissedForPage, markNoticeDismissedForPage} from '@github-ui/copilot-chat-helpers/copilot-onboarding'
import {noticeDismissalsPath} from '@github-ui/paths'
import {useQuery} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export function useNoticeDismissal(noticeName: string, {enabled}: {enabled: boolean}) {
  return useQuery({
    queryKey: ['notice-dismissal', noticeName],
    queryFn: async ({signal}) => {
      if (isNoticeDismissedForPage(noticeName)) return true
      const response = await reactFetchJSON(noticeDismissalsPath({noticeName}), {signal})
      if (!response.ok) throw new Error(`Unable to read notice dismissal ${noticeName}: ${response.status}`)
      const result: {dismissed: boolean} = await response.json()
      if (typeof result.dismissed !== 'boolean') throw new Error(`Invalid notice dismissal for ${noticeName}`)
      if (result.dismissed) markNoticeDismissedForPage(noticeName)
      return result.dismissed
    },
    enabled: enabled && !isNoticeDismissedForPage(noticeName),
    staleTime: Infinity,
  })
}
